import { render, staticRenderFns } from "./RecentProjects.vue?vue&type=template&id=26675711&"
import script from "./RecentProjects.vue?vue&type=script&lang=js&"
export * from "./RecentProjects.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports